import MaintenanceIcon from "../../images/maintenance.svg";
import RecommendationIcon from "../../images/recommendation.svg";
import HazardIcon from "../../images/hazard.svg";

export const CONCERN_LEVEL_OPTIONS = [
  { value: 0, label: "Maintenance Item", iconSrc: MaintenanceIcon },
  { value: 1, label: "Recommendation", iconSrc: RecommendationIcon },
  { value: 2, label: "Safety Hazard", iconSrc: HazardIcon },
];

export const ACCEPTED_IMAGE_TYPES = "image/jpeg,image/png,image/webp";

// Plural item.type (from editContent.js) → capitalized slice type used by
// ITEM_TYPE_TO_ENDPOINT in slice.js.
export const PLURAL_TO_CAPITAL = {
  issues: "Issue",
  infos: "Info",
  limits: "Limit",
  overviews: "Overview",
};

// Overview returns null — caller decides what to render in its place.
export const badgeFor = (item) => {
  if (item.type === "limits") return { label: "Limit", className: "limit" };
  if (item.type === "infos") return { label: "Info", className: "info" };
  if (item.type === "issues") {
    if (item.concern_level === 2)
      return { label: "Safety Hazard", className: "hazard" };
    if (item.concern_level === 1)
      return { label: "Recommendation", className: "recommendation" };
    return { label: "Maintenance", className: "maintenance" };
  }
  return null;
};
